import * as React from "react";
import "myshubhlife-component/inputTextField/index.scss";
import "./index.scss";
import {useState} from 'react';
import {SelectStyle} from "myshubhlife-component/selectField/style";

interface ISelectFieldProps {
  name?: string;
  options: IOptions[];
  value?: string | number;
  fieldName: string;
  errorMsg?: string;
  validated?: Validated;
  onChangeHandler: (fieldName: string, value: string | number, index?: number, identifier?: string, event?: React.FormEvent<HTMLInputElement>) => void;
  handleBlur?: (value: string | number) => void;
  disabled?: boolean;
  isRequired?: boolean;
  index?: number;
  tooltipLabel?: string;
  styleType?: string;
}

type Validated = 'success' | 'warning' | 'error' | 'default';

interface IOptions {
  name: string;
  value: string | number;
  isDisabled?: boolean;
}

enum STYLETYPE {
    ROUNDED_INPUT = 'rounded',
    BORDER_BOTTOM_INPUT = 'line',
    DEFAULT = 'default'
}
function SelectField (props: ISelectFieldProps) {
    const [focus, changeFocus] = useState(false);

    const handleBlur = (event) => {
      if (props.handleBlur) {
        props.handleBlur(event.currentTarget.value);
      }
      changeFocus(false);
    };

    return (
        <div className="select-field-container">
          <div className="label-wrapper">
            <label
                style={STYLETYPE.ROUNDED_INPUT === props.styleType  ? SelectStyle.roundedStyle['label']: STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType  ? SelectStyle.lineStyle['label']: STYLETYPE.DEFAULT === props.styleType  ? SelectStyle.defaultStyle['label']: {}}
                htmlFor={props.fieldName}>
                {props.name}
            </label>
            {props.errorMsg && (
                <label
                    htmlFor={props.fieldName}
                    className="label-error">
                    {props.errorMsg}
                </label>
            )}
          </div>
            {!props.isRequired && <span className="form-optional">Optional</span>}
            {props.tooltipLabel && 
              <div className="form-tooltip">
                <span className="form-tooltiptext form-tooltip-right">{props.tooltipLabel}</span>
              </div>
            }
            <select
                id={props.fieldName}
                className="s-form-select-control"
                value={props.value}
                style={
                  STYLETYPE.ROUNDED_INPUT === props.styleType ? focus ? {...SelectStyle.roundedStyle['default'], ...SelectStyle.roundedStyle['focus']} : SelectStyle.roundedStyle['default']: 
                  STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ? focus ? {...SelectStyle.lineStyle['default'], ...SelectStyle.lineStyle['focus']} : SelectStyle.lineStyle['default']: 
                  STYLETYPE.DEFAULT === props.styleType ?  focus ? {...SelectStyle.defaultStyle['default'], ...SelectStyle.defaultStyle['focus']} : SelectStyle.defaultStyle['default']: {}}
                onChange={(e) => props.onChangeHandler(props.fieldName, e.target.value)}
                onBlur={handleBlur}
                onFocus={() => changeFocus(true)}
                disabled={props.disabled ? props.disabled : false}>
                {props.options.map((item, index) => {
                    return (
                        <option disabled={item.isDisabled} style={STYLETYPE.ROUNDED_INPUT === props.styleType ? SelectStyle.roundedStyle['optionStyle']: STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ? SelectStyle.lineStyle['optionStyle']: STYLETYPE.DEFAULT === props.styleType ? SelectStyle.defaultStyle['optionStyle']: {}} value={item.value} key={index}>
                            {item.name}
                        </option>
                    );
                })}
            </select>
            {props.errorMsg ?
                <div className="error-message flex-center-row">
                    {props.errorMsg}
                </div> : null}
        </div>
    );
}

SelectField.defaultProps = {
    isRequired: true,
    styleType: 'default',
};
 
export default SelectField;
